import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import {changeCartItemQuantity} from "../../../actions/actionFunctions";
import {cartItemInterface} from "../cartItemInterface";
import {getFeatureUnit, toFixedFeatureCost} from "../../../misc/helpers";
import CartItemCalcButton from "./cartItemCalcButton";
import {COUNTERTOP_GROUP} from "../../kvComponent/core/constants";
import {MEASURE_UNITS} from "../../sqft/constants";

const CartItemQuantity = (props) => {

  const {cartItem, subPart, changeCartItemQuantity, isEmpty, id, propsQuantity, setParentQuantity, intl, fabricatorData,
    setClickedItemActiveQuoteIndex, isDisabled} = props;
  const {measureUnit} = fabricatorData.settings;
  const [quantity, setQuantity] = useState("");
  const MAX = 99999;

  let unit = "";
  if (cartItem.isEmpty) {
    const navItems = subPart.part.navigationSubItems();
    if (navItems.length && navItems[0].part.dbFeature.unit) {
      unit = navItems[0].part.dbFeature.unit;
    }
  } else {
    unit = getFeatureUnit(cartItem.cartFeature, intl, fabricatorData, quantity);
  }

  const availableMeasureUnits = [...COUNTERTOP_GROUP, "edge", "edge_profile", "center_island_edge"];
  const lowerCasedUnit = unit.toLowerCase();
  const allowDecimals = (measureUnit === MEASURE_UNITS.Metric) && (
    availableMeasureUnits.includes(subPart.part.partId) || ["lm", "sm", "mm"].some(um => um === lowerCasedUnit)
  );

  const updateQuantity = (quan) => {
    setQuantity(quan);
    setParentQuantity(quan); // this is needed to pass to search component
  };

  useEffect(() => {
    if (cartItem && cartItem.cartFeature) {
      const cartItemQuantity = cartItem.displayFakeQuantity ? cartItem.displayFakeQuantity : cartItem.quantity;
      updateQuantity(cartItemQuantity || 0);
    } else if (isEmpty) {
      updateQuantity("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEmpty, id, propsQuantity]); // (remove value if cart item was deleted)

  const handleInputChange = (e) => {

    if (cartItem.isMinimumCharge) {
      return false
    }

    let value = "" + e.target.value;

    if (value.includes(".")) {
      if (!allowDecimals) {
        return false
      }
      if (value.split(".")[1].length > 2) {
        value = +value.substring(0, value.length - 1); //round to 2 decimals
      }
    }

    value = +value;

    if (value <= MAX) {
      value = value === 0 ? "" : value;
      updateQuantity(value);
      if (!cartItem.isEmpty) {
        changeCartItemQuantity(cartItem, value, true)
      }
    }
  };

  const handleInputBlur = (event) => {
    if (!(+event.target.value)) {
      updateQuantity(1);
      if (!cartItem.isEmpty) {
        changeCartItemQuantity(cartItem, 1, true)
      }
    }
  };

  const handleOnKeyDown = (event) => {
    if (event.key === '-' || (event.key === '.' && !allowDecimals)) {
      event.preventDefault();
      return false
    }
  };

  if (cartItem.partId === "room") {
    if (cartItem.isEmpty || !toFixedFeatureCost(cartItem.cartFeature, cartItem.quantity, cartItem.fromQtCategory, false, null, false, cartItem.currentQuote)) {
      return <div className="aq-cell aq-cell--quantity"/>
    }
  }

  const isInputDisabled = cartItem.isMinimumChargeItems || isDisabled;

  return (
    <div className="aq-cell aq-cell--quantity">
      {cartItem.isMinimumCharge && !cartItem.isMinimumChargeItems ? null : <div className="aq-title">{unit}</div>}
      {cartItem.isMinimumCharge && !cartItem.isMinimumChargeItems ? null : (
        <div className="aq-main">
          <div className="aq-main__input">
            <input className={"ui-input ui-input--new ui-input--gray ui-input--number" + (isInputDisabled ? " ui-input--disabled" : "")}
                   type="number"
                   min="0"
                   // disabled={cartItem.isMinimumChargeItems || (cartItem.partId === SQFT_FEATURES.slabs)} // should slabs be editable?
                   disabled={isInputDisabled}
                   value={quantity}
                   pattern="^\d+(?:\.\d{1,2})?$"
                   onKeyDown={handleOnKeyDown}
                   onBlur={handleInputBlur}
                   onChange={handleInputChange}/>
          </div>
          <CartItemCalcButton cartItem={cartItem} setClickedItemActiveQuoteIndex={setClickedItemActiveQuoteIndex}/>
        </div>
      )}
    </div>
  )
};

CartItemQuantity.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface),
  setParentQuantity: PropTypes.func.isRequired,
  subPart: PropTypes.object.isRequired,
  setClickedItemActiveQuoteIndex: PropTypes.func,
  isDisabled: PropTypes.bool,
};

const mapStateToProps = (store, ownProps) => {
  return {
    fabricatorData: store.fabricatorState,
    isEmpty: ownProps.cartItem.isEmpty,
    id: ownProps.cartItem.id,
    propsQuantity: ownProps.cartItem.quantity,
  };
};

const mapDispatchToProps = {
  changeCartItemQuantity
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(CartItemQuantity)
)
